module.exports = __webpack_public_path__ + "fonts/iconfont.cc68c27.ttf";